<div class="general-container">
  <div *ngIf="!loading">
    <div *ngIf="step === 'allCommunications'">
      <div class="flex justify-center w-full h-full pt-32">
        <div class="flex flex-col gap-16 md:gap-24 items-center justify-center w-full max-w-[636px]">
          <fun-icon [name]="'bell'" [style]="'w-72 h-72 stroke-[2px] stroke-orange-100'"></fun-icon>
          <p class="text-h500 md:text-h600 font-sans text-center text-eggplant-100 md:pt-12">{{ title }}</p>
          <p class="font-sans text-m md:text-l text-center text-eggplant-100/[0.55] [&>span]:text-orange-100 [&>span]:underline [&>span]:underline-offset-6" [innerHTML]="subtitle"></p>
        </div>
      </div>

      <div class="flex justify-center w-full h-full py-24 md:py-32 px-12">
        <div *ngIf="variant === 'test'"  class="flex flex-col w-full md:max-w-[520px] items-center justify-center px-6">
          <fun-overviiew-status-avatars [investors]="102" [version]="'dark'" [size]="'m'" [status]="4"
          specificText="{{ 'NOTIFICATIONS.TEXT_MORE_THAN' | translate }}"></fun-overviiew-status-avatars>
        </div>
        <div *ngIf="variant !== 'test'"  class="flex flex-col w-full md:max-w-[360px] items-center justify-center rounded rounded-3xl shadow-l transition-all
        hover:outline-2 hover:outline-orange-100 hover:shadow-m !outline duration-500 focus:!outline-2 focus:!outline-orange-100 focus:shadow-l
        md:focus:shadow-xl md:hover:shadow-l md:p-16 md:rounded-[32px] md:shadow-xl outline-1 outline-orange-100/[.25] p-12">
          <p class="font-sansMedium line-clamp-2 md:text-2xl text-left text-xl hover:text-orange-100 text-eggplant-80 pb-16 pt-12">Proyecto Solar Cartagena (Murcia) </p>
          <div class="flex w-full gap-12 justify-around mb-12">
            <div class="flex flex-col">
              <div class="flex gap-6 items-center">
                <fun-icon [name]="'clock'" [style]="'w-[18px] h-[18px] stroke-[4px] stroke-eggplant-100'"></fun-icon>
                <p class="font-sans text-eggplant-100 text-l md:text-xl">{{ 'NOTIFICATIONS.ONE_HOUR' | translate }}</p>
              </div>
              <p class="text-eggplant-100/[.25] text-m font-sans">{{ 'NOTIFICATIONS.FINANCED_IN' | translate }}</p>
            </div>
            <div class="flex flex-col">
              <div class="flex gap-6 items-center">
                <fun-icon [name]="'arrow-trendingup'" [style]="'w-[18px] h-[18px] stroke-[4px] stroke-eggplant-100'"></fun-icon>
                <p class="font-sans text-eggplant-100 text-l md:text-xl">7,05%</p>
              </div>
              <p class="text-eggplant-100/[.25] text-m font-sans">{{ 'AUTOINVEST.STEP_5.PROF' | translate }}</p>
            </div>
            <div class="flex flex-col">
              <div class="flex gap-6 items-center">
                <fun-icon [name]="'users'" [style]="'w-[18px] h-[18px] stroke-[4px] stroke-eggplant-100'"></fun-icon>
                <p class="font-sans text-eggplant-100 text-l md:text-xl">45</p>
              </div>
              <p class="text-eggplant-100/[.25] text-m font-sans">{{ 'NOTIFICATIONS.INVESTORS' | translate }}</p>
            </div>
          </div>
          <footer class="h-[112px] h-[96px] md:h-[146px] md:rounded-3xl min-w-[264px] relative rounded-2xl w-full" style="background-image: url(&quot;https://fundeen-front-images.s3-eu-west-1.amazonaws.com/pro/projects/20/TarjetaCartagena.png&quot;); background-size: cover; background-position: center center;"></footer>
        </div>
      </div>

      <div class="flex justify-center w-full h-full pb-32 md:pb-32">
        <div class="flex flex-col gap-8 md:gap-16 items-center justify-center w-full max-w-[720px]">
          <fun-new-button  [classExtra]="' !w-full '" [buttonType]="'colorFull'" [size]="'xl'" title="{{ 'NOTIFICATIONS.ACTIVATE_NOW' | translate }}" (eventClick)="subscribeToCommunications()" icon="rocket" iconPosition="right"></fun-new-button>
          <fun-new-button  [classExtra]="' !w-full '" [buttonType]="'ghost'" [size]="'s'" title="{{ 'NOTIFICATIONS.REMEMBER_ME' | translate }}" (eventClick)="closeModal()"></fun-new-button>
          <p class="font-sans text-m md:text-m text-eggplant-100/[0.55] text-center">{{ 'NOTIFICATIONS.UNSUBSCRIBE_ANY_TIME' | translate }}</p>
        </div>
      </div>
    </div>
    <!-- <fun-overal-message *ngIf="step === 'allCommunications'" [text]="textAll" [image]="8" [btnList]="btnList"
    (btnEvent)="allCommunications($event)"></fun-overal-message> -->
    <fun-overal-message *ngIf="step === 'confirmed'" [text]="textConfirmed" [image]="imageconfirmed" [btnList]="btnConfirmedList"
    (btnEvent)="confirmedAction($event)"></fun-overal-message>
  </div>
  <div class="pb-120" *ngIf="loading">
    <fun-spinner></fun-spinner>
  </div>

</div>
